// removed by extract-text-webpack-plugin
module.exports = {"switch":"qempo_InputSwitch_switch-2Pyz7nA","slider":"qempo_InputSwitch_slider-1YQ10hF","round":"qempo_InputSwitch_round-1P1eApZ"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/InputSwitch/InputSwitch.scss
// module id = 1374
// module chunks = 0